import PageCommon from "./PageCommon";

import Globals from "../Globals.js";

export default class IndexedDBManager extends PageCommon {
    constructor() {
        super();
        this.windowIndexedDB = null;

        this.idb = null;
        this.dbName = "";
    }
    init({ windowIndexedDB, dbName }) {
        super.init();
        this.windowIndexedDB = windowIndexedDB;
        this.dbName = dbName;
    }
    open() {
        const _this = this;
        const request = this.windowIndexedDB.open(this.dbName, 1);
        request.onerror = () => {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Database failed to open");
        };
        request.onsuccess = () => {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Database opened successfully");
            _this.idb = request.result;
            _this.emitEvent("idb_ready");
        };
        request.onupgradeneeded = (event) => {
            _this.idb = event.target.result;
            let objectStore = _this.idb.createObjectStore(_this.dbName, { keyPath: "id" });
            objectStore.createIndex("file", "file", { unique: false });
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Database setup complete");
        };
    }

    add(item, name) {
        const newItem = { id: 1, file: item, name: name };

        const transaction = this.idb.transaction(this.dbName, "readwrite");
        const objectStore = transaction.objectStore(this.dbName);

        const request = objectStore.add(newItem);
        request.onsuccess = () => {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Database Item saved");
        };
        transaction.oncomplete = () => {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Transaction completed: database modification finished.");
        };
        transaction.onerror = () => {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Transaction not opened due to error");
        };
    }

    read(id) {
        const objectStore = this.idb.transaction(this.dbName).objectStore(this.dbName);
        const request = objectStore.get(id);
        request.onsuccess = () => {
            if (request.result) {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Database file loaded");
                this.emitEvent("video_found", { detail: request.result });
            } else {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Database can't find the video");
            }
        };
    }

    delete(id) {
        if (this.idb) {
            let transaction = this.idb.transaction(this.dbName, "readwrite");
            let objectStore = transaction.objectStore(this.dbName);
            let request = objectStore.delete(id);
            transaction.oncomplete = () => {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Database " + id + " deleted.");
            };
        }
    }
}
